<template>
  <div v-if="show" class="col-xs-12 col-md-3">
    <form-group-cpf
      ref="input"
      type="text"
      :label="label"
      :readonly="readonly"
      :value="value"
      :placeholder="placeholder"
      :name="name"
      :data-vv-as="label"
      @input="$emit('input', $event)"
      @blur="$updateValuesConvenio($event)"
      v-validate="{ required: required, cpf: true }"
    />
  </div>
</template>

<script>
import verificaTipoPessoa from "../../../../mixins/protocolo/verificaTipoPessoa";
import convenio from "../../../../mixins/protocolo/convenio";
export default {
  $_veeValidate: {
    validator: "new"
  },
  inject: ["$validator", "formValues"],
  name: "c-protocolo-cpf",
  props: {
    label: String,
    id: String,
    name: {
      required: true,
      type: String
    },
    disabled: Boolean,
    placeholder: String,
    readonly: Boolean,
    value: String,
    required: Boolean,
    campoId: Number,
    loading: {
      type: Boolean,
      default: false
    }
  },
  mixins: [verificaTipoPessoa, convenio],
  data() {
    return {
      show: true
    };
  },
  asyncComputed: {
    verificar() {
      this.show = !this.$isJuridica(this.formValues);
    }
  },
  mounted() {
    this.$el.value = this.value;
  }
};
</script>



// WEBPACK FOOTER //
// src/components/UIComponents/Protocolo/Campos/Cpf.vue